import english from "./english";

const languagePack = {
  "en-US": english
};

export default languagePack[navigator.language] || languagePack["en-US"];
